import { useAuth0 } from '@auth0/auth0-react';
import { LogOut } from 'lucide-react';

import NavMenuItem from './NavMenuItem';
import { LABEL_CLASS, navRowClass, type NavItemVariant } from './navRowClass';
import { clearRecentSearches } from './search/recent-searches';

interface SignOutItemProps {
  /** `menu` is the avatar-popover row; the rest match the nav row shapes so
   *  the panel footer and the drawer can render sign-out inline. */
  variant?: NavItemVariant | 'menu';
}

/** The app's only sign-out. Rendered in the avatar popover, the nav panel
 *  footer and the mobile drawer — one `logout()` call behind all three. */
export default function SignOutItem({ variant = 'menu' }: SignOutItemProps) {
  const { logout } = useAuth0();
  const signOut = () => {
    clearRecentSearches();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  if (variant === 'menu') {
    return <NavMenuItem icon={LogOut} label="Sign out" tone="danger" onClick={signOut} />;
  }

  return (
    <button
      type="button"
      onClick={signOut}
      aria-label="Sign out"
      title="Sign out"
      className={`${navRowClass(variant)} cursor-pointer`}
      style={{ color: '#c2410c' }}
    >
      <LogOut size={18} aria-hidden className="shrink-0" />
      <span className={LABEL_CLASS[variant]}>Sign out</span>
    </button>
  );
}
